export default "__VITE_ASSET__ece87ff3__"